export { ProductSpotlight } from './ProductSpotlight';
